import React from 'react';
import PropTypes from 'prop-types';

class Authorization extends React.PureComponent {
  getCurrentRole() {
    let role = localStorage.getItem('escenaRole');

    if (!role) {
      role = 'guest';
    }

    return role;
  }

  getCurrentPlan = () => localStorage.getItem('escenaPlan');

  isAllowed() {
    const role = this.getCurrentRole();

    let allowedRoles = this.props.allowed;
    if (typeof allowedRoles === 'string') {
      allowedRoles = [allowedRoles];
    }

    allowedRoles = allowedRoles.map(v => v.trim().toLowerCase());

    return allowedRoles.indexOf(role.trim().toLowerCase()) > -1;
  }

  isDeniedPlan() {
    const plan = this.getCurrentPlan();
    const { deniedPlans } = this.props;
    return deniedPlans.indexOf(plan) > -1;
  }

  isAllowedPlan() {
    const plan = this.getCurrentPlan();
    const { allowedPlans } = this.props;
    return allowedPlans.indexOf(plan) > -1;
  }

  isDenied() {
    const role = this.getCurrentRole();

    let deniedRoles = this.props.denied;
    if (typeof deniedRoles === 'string') {
      deniedRoles = [deniedRoles];
    }

    deniedRoles = deniedRoles.map(v => v.trim().toLowerCase());

    return deniedRoles.indexOf(role.trim().toLowerCase()) > -1;
  }

  render() {
    const deniedByPlan = this.props.deniedPlans && this.props.deniedPlans.length > 0 && this.isDeniedPlan();
    const deniedByRole = this.props.denied && this.props.denied.length > 0 && this.isDenied();
    let allowedbyRole = true;
    let allowedbyPlan = true;
    if (this.props.allowed && this.props.allowed.length > 0) {
      allowedbyRole = this.isAllowed();
    }
    if (this.props.allowedPlans && this.props.allowedPlans.length > 0) {
      allowedbyPlan = this.isAllowedPlan();
    }
    if (
      (!deniedByPlan && !deniedByRole && allowedbyRole && allowedbyPlan)
    ) {
      return this.props.children;
    }
    return <span />;
  }
}

Authorization.propTypes = {
  children: PropTypes.node,
  deniedPlans: PropTypes.array,
  allowedPlans: PropTypes.array,
  allowed: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
  denied: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
};

Authorization.defaultProps = {
  children: undefined,
  allowed: [],
  denied: [],
  deniedPlans: [],
  allowedPlans: [],
};

export default Authorization;



// WEBPACK FOOTER //
// ./src/components/Authorization/index.js